module.exports = __webpack_public_path__ + "static/media/gcash.5f739496.png";